import { render } from "./ProductLayout.vue?vue&type=template&id=10ab8d00&scoped=true"
import script from "./ProductLayout.vue?vue&type=script&lang=js"
export * from "./ProductLayout.vue?vue&type=script&lang=js"

import "./ProductLayout.vue?vue&type=style&index=0&id=10ab8d00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ab8d00"]])

export default __exports__